import {createSlice} from "@reduxjs/toolkit";

export const initialState = {
    currentPage: 1,
    pageSize: 10,
};

export const microqualificationGroupsListTableControllerSlice = createSlice({
    name: 'microqualificationGroupsListTableControllerSlice',
    initialState,
    reducers: {
        changeCurrentPage(state, action) {
            state.currentPage = action.payload.page;
            state.pageSize = action.payload.pageSize;
        },
    },
});

export const {changeCurrentPage} = microqualificationGroupsListTableControllerSlice.actions;

export default microqualificationGroupsListTableControllerSlice.reducer;
